<template>
  <div class="wrapper">
    <Breadcrumb v-if="pageName" :pageName="pageName"></Breadcrumb>
    <slot class="content"/>
  </div>
</template>

<script>
import Breadcrumb from './Breadcrumb.vue'
export default {
  name: 'Wrapper',
  components: {
    Breadcrumb
  },
  props: {
    pageName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.wrapper {
  background: #eee;
  width: 100%;
  height: 100%!important;
  display: flex;
  flex-direction: column;
  .content{
    flex-grow: 1;
  }
}
</style>
